<template>
  <div class="device_wraper ">
    <!-- ///拖动组件 -->
    <draggable v-model="DdeviceList" @update="datadragEnd" v-bind="sortableOptions">
      <transition-group>
        <!-- 单个设备对象组件 -->
        <device-item-view v-for="(value, index) in DdeviceList" :key="value.deviceId + value.productId"
          :oneDevice="DdeviceList[index]" :viewType="viewType" @followOrderCompuder="followOrderCompuder"
          @followOrderCompuInc="followOrderCompuInc"></device-item-view>

        <!-- ///////拖动组件 -->
      </transition-group>
    </draggable>
  </div>
</template>

<script>
import {
  computerNotShowEleCoun,
  judgeActivePage,
  changefollowOrder,
  changefollowOrderInc
} from 'common/tool'

import DeviceItemView from 'components/content/contro-view/device-view/device-item-view'

import draggable from 'vuedraggable' /////拖动插件
import store from 'store/index' ///导入公共仓库

export default {
  data() {
    return {
      DdeviceList: this.deviceList,////拖动的需要,这里只在第一次加载的时候会获取，但有可能获取的是空的，因为网络请求延时，为了排序需要，所有需要监听改变，重新赋值。

      // objectMoveState: store.state.configinfo.objectMoveState /////是否允许拖拽排序
    }
  },
  components: {
    DeviceItemView,
    draggable
  },
  props: {
    deviceList: Array,
    viewType: {
      type: String,
      default: ''
    }
  },
  computed: {
    sortableOptions() {
      return {
        animation: 500,
        sort: this.$store.state.configinfo.objectMoveState,
        disabled: !this.$store.state.configinfo.objectMoveState, // 禁止拖拽
        scroll: true,
      };
    },
  },
  methods: {
    getdata(evt) {
      console.log(evt.draggedContext.element.text)
    },
    datadragEnd(evt) {
      evt.preventDefault()
      console.log('拖动前的索引 :' + evt.oldIndex)
      console.log('拖动后的索引 :' + evt.newIndex)
      console.log(this.DdeviceList)
    },
    followOrderCompuder(val) {
      console.log('点击了取消收藏')
      console.log(val)
      changefollowOrder(this.DdeviceList, val)
    },
    followOrderCompuInc(val) {
      console.log('点击了添加收藏')
      console.log(val)
      changefollowOrderInc(this.DdeviceList, val)
    }
  },
  watch: {
    // 拖动功能需要
    deviceList: {
      handler(newValue, oldValue) {
        console.log('设备展示数据发生了改变')
        // 监听设备展示数据是否发生变化
        this.DdeviceList = newValue ////重新赋值
        // console.log(oldValue)
      },
      deep: true //深度监听,监听数组的第二层数据变化
    },
    DdeviceList: {
      handler(newValue, oldValue) {
        console.log('设备展示数据发生了改变1')
        let page = judgeActivePage()
        if (page === '区域') {
          this.$store.dispatch(
            'asyUpdataregionServeDatadeviceList',
            this.DdeviceList
          ) ///异步提交当前页面需要展示的控制数据
        } else if (page === '常用') {
          this.$store.dispatch(
            'asyUpdatahomeServeDatadeviceList',
            this.DdeviceList
          ) ///异步提交当前页面需要展示的控制数据
        }

        // this.DdeviceList = newValue ////重新赋值
        ///界面管理数据的同步，这样做可以做到全面数据的状态更新同步
        // this.$store.dispatch('asyUpdataServeDatadeviceList', this.DdeviceList) ///异步提交当前页面需要展示的控制数据
        // 监听设备展示数据是否发生变化
        // this.DdeviceList = newValue ////重新赋值
        // console.log(oldValue)
      },
      deep: true //深度监听,监听数组的第二层数据变化
    }
  },
  mounted() {
    // 拖动功能需要
    //为了防止火狐浏览器拖拽的时候以新标签打开，此代码真实有效
    document.body.ondrop = function (event) {
      event.preventDefault()
      event.stopPropagation()
    }
  }
}
</script>

<style>
/* 这里修改添加拖动元素组件 */
.device_wraper>div>span {
  width: 100%;
  height: 100%;
  margin-bottom: 150px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: center;
  align-items: center;
}
</style>
